enum FlowEnum {
  CHECK_PRIVATE = 3,
  CHECK_BUSINESS = 4,
}

const FlowSourceMap = {
  [FlowEnum.CHECK_PRIVATE]: 'PL',
  [FlowEnum.CHECK_BUSINESS]: 'PL',
};

export { FlowEnum as default, FlowSourceMap };
